import axios from 'axios';
import CustomTransforms from "../transforms";

export default class QuizService {
    doGetQuizById(id) {
        return axios.get(`/api/quiz/${id}?language=${language}`);
    }

    doGetUsersQuiz() {
        const headers = {
            headers: {
                'Authorization': `Bearer ${localStorage.token}`
            }
        };

        return axios.get(`/api/quiz/list/user?language=${language}`, headers);
    }

    doSaveAnswersByQuizId(id, arr) {
        const config = {},
            data = {
                'quiz': id,
                'answers': arr
            };

        if (localStorage.token) {
            config.headers = {
                'Authorization': `Bearer ${localStorage.token}`
            }
        }

        return axios.post(`/api/quiz/answers/user?language=${language}`, data, config);
    }

    generateOfflineQuizResult(answersIds, questions) {
        // Get more repeated needscope in the answers
        let needscopes = [],
            transform = new CustomTransforms();

        questions.map((item) => item.answers.map((answer) => {
            // If answer is one of the ones chosen add needscope
            if (answersIds.includes(answer.id)) {
                needscopes.push(answer.needscope);
            }
        }));

        // Check which needscope ID has repeated more
        let needscopesId = transform.mostFrequentItemInArray(needscopes.map((item) => item.id));
        const result = needscopes.filter((item) => item.id === needscopesId);
        return result.length ? result[0] : result;
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/quiz-service.js